import Swiper, {EffectCreative, EffectFade, Navigation, Pagination} from 'swiper';

const infoBlockSliders = Array.from(document.querySelectorAll('.j-info-slider-wrapper'));

let imageSwiper = {};
let textSwiper = {};

const textOptions = {
    modules          : [EffectFade],
    init             : false,
    loop             : true,
    speed            : 1000,
    spaceBetween     : 0,
    slidesPerView    : 1,
    slidesOffsetAfter: 0,
    effect           : 'fade',
    fadeEffect       : {
        crossFade: true
    }
};

/* eslint-disable max-lines-per-function */
if (infoBlockSliders.length) {
    infoBlockSliders.forEach((wrapper) => {
        const counter = wrapper.querySelector('.j-info-block-pagination');

        const slider = wrapper.querySelector('.j-info-block-slider');
        const textSlider = wrapper.querySelector('.j-info-block-text-slider');

        const options = {
            modules          : [EffectCreative, Navigation, Pagination],
            loop             : true,
            speed            : 1000,
            spaceBetween     : 0,
            slidesPerView    : 1,
            slidesOffsetAfter: 0,
            effect           : 'creative',
            creativeEffect   : {
                prev: {
                    translate: ['-20%', 0, -1]
                },
                next: {
                    translate: ['100%', 0, 0]
                }
            },
            pagination: {
                el  : counter,
                type: 'custom',
                renderCustom(_, current, total) {
                    return `<span class="slider-control__current">${current.toString().padStart(2, '0')}</span>
                               <span class="slider-control__total">/ ${total.toString().padStart(2, '0')}</span>`;
                }
            },
            navigation: {
                nextEl: '.j-info-block-next',
                prevEl: '.j-info-block-prev'
            },
            breakpoints: {
                1280: {
                    allowTouchMove: false,
                    spaceBetween  : 0
                }
            }
        };

        if (textSwiper) {
            textSwiper = new Swiper(textSlider, textOptions);
            textSwiper.init();

            textSwiper.on('slideChange', () => {
                imageSwiper.slideTo(textSwiper['activeIndex']);
            });
        }

        imageSwiper = new Swiper(slider, options);
        imageSwiper.init();

        imageSwiper.on('slideChange', () => {
            textSwiper.slideTo(imageSwiper['activeIndex']);
        });
    });
}
/* eslint-enable max-lines-per-function */
